import React, { Component } from 'react';
import Header from 'components/Header/Header';
import Navigation from 'navigation/navigation';
import PodcastStyle from '../podcast/Podcast.module.css';
import PagerStyle from '../trending/Trending.module.css';

class SeeAll extends Component {
    constructor(props) {
        super(props);
        const { state } = this.props.location || {};
        let allItems = (state && Array.isArray(state.podcasts)) ? state.podcasts : [];
        let title = (state && state.title) || 'Podcasts';
        // Fallback to session storage if navigation state missing
        if (!allItems.length) {
            try {
                const raw = sessionStorage.getItem('seeAllPayload');
                if (raw) {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed.podcasts)) {
                        allItems = parsed.podcasts;
                        title = parsed.title || title;
                    }
                }
            } catch {}
        }
        this.state = {
            title,
            allItems,
            page: 1,
            pageSize: 15,
        };
    }

    componentDidMount() {
        const { title, allItems } = this.state;
        try {
            sessionStorage.setItem('seeAllPayload', JSON.stringify({ title, podcasts: allItems }));
        } catch {}
        // If still no data, redirect to Discover as a safe fallback
        if (!Array.isArray(allItems) || allItems.length === 0) {
            this.props.history.replace('/podcast');
        }
    }

    getCurrentPageItems = () => {
        const { allItems, page, pageSize } = this.state;
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        return allItems.slice(start, end);
    };

    handleNextPage = () => {
        const { allItems, page, pageSize } = this.state;
        const nextStart = page * pageSize;
        if (nextStart >= allItems.length) return;
        this.setState({ page: page + 1 });
    };

    handlePrevPage = () => {
        const { page } = this.state;
        if (page <= 1) return;
        this.setState({ page: page - 1 });
    };

    handleCardClick = (item) => {
        const podcastId = (item && (item.id || item._id || item.podcastId || item.podcast_id));
        if (!podcastId) return;
        // Ensure back from detail returns to this SeeAll view with current data
        this.props.history.push({
            pathname: `/podcastdetail/${podcastId}`,
            state: {
                backTo: {
                    pathname: '/podcastlist',
                    state: { title: this.state.title, podcasts: this.state.allItems }
                }
            }
        });
    };

    render() {
        const { title, allItems, page, pageSize } = this.state;
        const items = this.getCurrentPageItems();
        const hasPrev = page > 1;
        const hasNext = (page * pageSize) < allItems.length;

        return (
            <div>
                <Header title={title} back={true} backHandler={() => this.props.history.goBack()} />
                <div className={PodcastStyle.contentSection} style={{ padding: '0 8px' }}>
                    <div className={PodcastStyle.divTitleSection}>
                        <div className={PodcastStyle.divTitleRow}>{title}</div>
                    </div>
                    <div className={PodcastStyle.itemsContainer}>
                        {items.map((podcast, index) => (
                            <div
                                key={podcast.id || podcast._id || index}
                                className={PodcastStyle.itemCard}
                                onClick={() => this.handleCardClick(podcast)}
                            >
                                <img
                                    src={podcast.image}
                                    alt={podcast.title}
                                    className={PodcastStyle.itemImage}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                                <div className={PodcastStyle.itemContent}>
                                    <div className={PodcastStyle.itemName}>{podcast.title}</div>
                                    <div className={PodcastStyle.itemAuthor}>by {podcast.author}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={PagerStyle.pagerBar}>
                        {hasPrev && (
                            <span className={`${PagerStyle.button}`} style={{ cursor: 'pointer' }} onClick={this.handlePrevPage}>&lt; Previous</span>
                        )}
                        {hasNext && (
                            <span className={`${PagerStyle.button}`} style={{ cursor: 'pointer' }} onClick={this.handleNextPage}>Next &gt;</span>
                        )}
                    </div>
                </div>
                <div style={{ height: '60px' }} />
                <Navigation active='Discover' />
            </div>
        );
    }
}

export default SeeAll;


